import React from 'react'
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Send, Image } from '@material-ui/icons';
import { Button } from '@material-ui/core';


const useStyles = makeStyles((theme) =>
    createStyles({
        wrapForm: {
            display: "flex",
            justifyContent: "center",
            width: "95%",
            margin: `${theme.spacing(0)} auto`
        },
        wrapText: {
            width: "100%",
            margin: "0 5px"
        },
        button: {
            //margin: theme.spacing(1),
        },
    })
);


export const TextInput = ({ message, setMessage, updateMessage, updateImage }) => {
    const classes = useStyles();
    const pressEnterKey = (e) => {
        if (message != "" && e.keyCode == 13) {
            updateMessage()
        }
    }

    const CaptureImage = (e) => {
        let item = e.clipboardData.items[0];
        if (item && item.type.includes("image")) {
            let file = item.getAsFile();
            updateImage(file)
        }
    }

    return (
        <>
            <div className={classes.wrapForm} noValidate autoComplete="off">
                <Button variant="contained" component="label" color="primary" size="small" style={{ maxWidth: '15%', minWidth: '15%' }}>
                    <input hidden type="file" accept="image/*" onChange={(e) => updateImage(e.target.files[0])} />
                    <Image />
                </Button>
                <TextField
                    id="message-box-text"
                    label="Message..."
                    className={classes.wrapText}
                    values={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={pressEnterKey}
                    onPaste={CaptureImage}
                />
                <Button size="small" variant="contained" color="primary" onClick={() => updateMessage()} className={classes.button} disabled={message != "" ? false : true} style={{ maxWidth: '15%', minWidth: '15%' }}>
                    <Send />
                </Button>
            </div>
        </>
    )
}



